import React from 'react';
import { CalendarIcon, ClipboardListIcon, HeartIcon } from 'lucide-react';
export function ProcessSteps() {
  return <section id="process" className="py-16 bg-[#9BAB6C]" data-id="element-272" data-mp="1t9ckw9rqaoai">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-273" data-mp="1p8siaqodysgz">
        <div className="text-center mb-16" data-id="element-274" data-mp="1p92e4uw43tul">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-275" data-mp="1k9z93ag4tnmm">
            How It Works
          </h2>
          <p className="text-xl text-white max-w-3xl mx-auto" data-id="element-276" data-mp="2h086uq9i6p9u">
            A simple, straightforward process to get your bookkeeping on track
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-277" data-mp="287oda482javv">
          {/* Step 1 */}
          <div className="bg-white rounded-lg p-8 relative hover:shadow-lg transition-shadow" data-id="element-278" data-mp="285bp39bpw4ad">
            <div className="absolute -top-5 -left-5 h-12 w-12 rounded-full bg-[#3A4A46] text-white flex items-center justify-center text-xl font-bold" data-id="element-279" data-mp="236qxfyaj6sxj">
              1
            </div>
            <div className="mb-6 text-[#8A9A5B]" data-id="element-280" data-mp="2vvxs2m6v6ydi">
              <CalendarIcon className="h-12 w-12" data-id="element-281" data-mp="2r1877xydqrdy" />
            </div>
            <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-282" data-mp="2w0l5deupbkvu">
              Schedule a Free Discovery Call
            </h3>
            <p className="text-gray-600" data-id="element-283" data-mp="2i9zk5jhryyus">
              Tell me about your business, your current setup, and your goals.
              No pressure, just a helpful conversation.
            </p>
          </div>
          {/* Step 2 */}
          <div className="bg-white rounded-lg p-8 relative hover:shadow-lg transition-shadow" data-id="element-284" data-mp="289fg692vfg8v">
            <div className="absolute -top-5 -left-5 h-12 w-12 rounded-full bg-[#3A4A46] text-white flex items-center justify-center text-xl font-bold" data-id="element-285" data-mp="2dbobhc37uue5">
              2
            </div>
            <div className="mb-6 text-[#8A9A5B]" data-id="element-286" data-mp="23cytljbbl9xw">
              <ClipboardListIcon className="h-12 w-12" data-id="element-287" data-mp="3tod4wfh8ey6l" />
            </div>
            <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-288" data-mp="3tp4mgmdzuvdv">
              Get a Clear Proposal
            </h3>
            <p className="text-gray-600" data-id="element-289" data-mp="1i7vocmkw572">
              I'll recommend the best package for your needs - flat-rate,
              transparent pricing with onboarding included.
            </p>
          </div>
          {/* Step 3 */}
          <div className="bg-white rounded-lg p-8 relative hover:shadow-lg transition-shadow" data-id="element-290" data-mp="11gay9su2mmha">
            <div className="absolute -top-5 -left-5 h-12 w-12 rounded-full bg-[#3A4A46] text-white flex items-center justify-center text-xl font-bold" data-id="element-291" data-mp="wi9awvpm4100">
              3
            </div>
            <div className="mb-6 text-[#8A9A5B]" data-id="element-292" data-mp="1p6nctmjtnhgu">
              <HeartIcon className="h-12 w-12" data-id="element-293" data-mp="1p6x2ta4v9omj" />
            </div>
            <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-294" data-mp="1kevkb6h3v1o2">
              Breathe Easy - Your Books Are Handled
            </h3>
            <p className="text-gray-600" data-id="element-295" data-mp="1fg2e7z45ecxx">
              Whether it's ongoing bookkeeping or a one-time clean-up, I'll get
              your numbers in order so you can focus on what matters most.
            </p>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-296" data-mp="2fgnqw41deidy">
          <a href="https://outlook.office.com/book/MeyerBookkeepingTax@meyerbkt.com/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#3A4A46] text-white px-6 py-3 rounded-md text-lg font-medium hover:bg-opacity-90 transition-colors" data-id="element-297" data-mp="2fhpcv3jxcpag">
            Book a Free Discovery Call
          </a>
        </div>
      </div>
    </section>;
}